import { useTranslations } from 'next-intl';
import React from 'react';
import type { RagnarButtonState } from '@mentimeter/ragnar-ui/button';
import { Button } from '@mentimeter/ragnar-ui/button';

export const VerifyEmailButton = ({
  buttonState,
}: {
  buttonState: RagnarButtonState | undefined;
}) => {
  const t = useTranslations('onboarding.join_workspace');
  return (
    <Button
      state={buttonState}
      aria-label={t('verify_email_button_label_a11y')}
      width="100%"
      variant="primary"
      type="submit"
      mx={0}
      mt="space2"
    >
      {t('verify_email_button')}
    </Button>
  );
};
